import { render } from "./PackageOrderGeneratorPricingDetailsSection.vue?vue&type=template&id=c8361654&scoped=true"
import script from "./PackageOrderGeneratorPricingDetailsSection.vue?vue&type=script&lang=js"
export * from "./PackageOrderGeneratorPricingDetailsSection.vue?vue&type=script&lang=js"

import "./PackageOrderGeneratorPricingDetailsSection.vue?vue&type=style&index=0&id=c8361654&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8361654"]])

export default __exports__